import React from 'react';
import { ClipLoader } from 'react-spinners';
import './Spinner.scss';
const Spinner = () => {
  return (
    <div className="cssload-container1">
      <div className="cssload-loader1">
        <ClipLoader
          sizeUnit={'px'}
          size={162}
          color="darkgreen"
          loading={true}
        />
      </div>
    </div>
  );
};

export default Spinner;
